import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetChat } from '../../store/chatBotEventsSlice';
import { Feedback } from './components/Feedback/Feedback';
import { GuidePrompts } from './components/Prompts/Guide/GuidePrompts';
import { GuidePromptsSearcher } from './components/Prompts/Guide/GuidePromptsSearcher/GuidePromptsSearcher';
import { Tips } from './components/Prompts/Tips/Tips';
import { ModalType } from './constants/enums';
import { IModalValue } from '../../interface/IModalValue';
import { Modal } from './components/Modal/Modal';
import { openOrCloseModal } from '../../store/modalActionsSlice';
// import { SideNav } from './components/SideNav/SideNav';
import { userSendPrompt } from '../../store/userSendPromptSlicer';
// import { Toolbar } from './components/Toolbar/Toolbar';
import { storeMessageReaction, storeProvideFeedback } from './functions/createFeedbackHistory';

import { Components, createDirectLine, createStore } from 'botframework-webchat';
import WebChat from './components/webChat/webChat';
import activityMiddleware from './functions/activityMiddleware';
import chatBotStyles from './functions/chatBotStyles';
import api from '././functions/api';
import iconBot from "../../Assets/chat/BotAvatarBlue.png";
import { faChevronUp, faCompress, faExpand, faLeftRight, faRightLeft, faUpDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


interface ChatBotProps {
  isOpen: boolean;
  isFull: boolean;
  setIsOpenbot: (isOpen: boolean) => void;
  setFull: (isFull: boolean) => void;
}

function ChatBot({isOpen,setIsOpenbot,isFull,setFull }: ChatBotProps) {
  const effectRan = useRef(false);
  const initialized = useRef(false);
  const dispatch = useDispatch();

  const [session, setSession] = useState<false | {
    directLine: ReturnType<typeof createDirectLine>;
    key: number;
    store: ReturnType<typeof createStore>;
  }>(false);
  const [tokenToFeedback, setTokenToFeedback] = useState<string>('');
  const aValue = localStorage.getItem("okta-token-storage")!;
  const oktadata = JSON.parse(aValue);
  const okta_id = oktadata.idToken.idToken;
  const [tokenOkta, setTokenOkta] = useState<string>(okta_id);


  const chatBotEvent = useSelector((state: any) => state.chatBotEvents.value);
  const modal = useSelector((state: any) => state.modalActions.value);
  const cardText = useSelector((state: any) => state.cardText.value);
  const homeVisibility = useSelector((state: any) => state.homeVisibility.value);

  const getToken = async () => {
    try {
      const botToken = await api.fetchToken();
      return botToken;
    } catch (error) {
      console.error('Error al obtener el token del bot:', error);
      return null;
    }
  };

  function isMarkdownTable(text: string): boolean {
    const lines = text.trim().split('\n');
  
    for (let i = 0; i < lines.length - 1; i++) {
      const line = lines[i].trim();
      const nextLine = lines[i + 1].trim();
  
      const isHeader = /^\s*\|.*\|\s*$/.test(line);
      const isSeparator = /^\s*\|[-| ]+\|\s*$/.test(nextLine);
  
      if (isHeader && isSeparator) return true;
    }
  
    return false;
  }
  
  function markdownTableToHtml(text: string): string {
    const lines = text.trim().split('\n');
    const tableLines: string[] = [];
    let introText = "";
  
    let tableStartIndex = -1;
  
    // Buscar inicio de tabla
    for (let i = 0; i < lines.length - 1; i++) {
      const current = lines[i].trim();
      const next = lines[i + 1].trim();
  
      if (
        /^\s*\|.*\|\s*$/.test(current) &&
        /^\s*\|[-| ]+\|\s*$/.test(next)
      ) {
        tableStartIndex = i;
        break;
      }
    }
  
    // Si no se encontró tabla, return vacío
    if (tableStartIndex === -1) return '';
  
    // Guardar el texto anterior a la tabla
    introText = lines.slice(0, tableStartIndex).join(' ').trim();
  
    // Agregar líneas de la tabla
    for (let i = tableStartIndex; i < lines.length; i++) {
      const row = lines[i].trim();
      if (/^\s*\|.*\|\s*$/.test(row)) {
        tableLines.push(row);
      } else {
        break;
      }
    }
  
    if (tableLines.length < 2) return '';
  
    const htmlRows = tableLines
      .filter((row, i) => {
        const isSeparator = /^\s*\|[-| ]+\|\s*$/.test(row);
        return !(i === 1 && isSeparator);
      })
      .map((row, i) => {
        const cols = row.split('|').slice(1, -1).map(col => col.trim());
        const tag = i === 0 ? 'th' : 'td';
        return `<tr>${cols.map(col => `<${tag}>${col}</${tag}>`).join('')}</tr>`;
      });
  
    const introHtml = introText ? `<p>${introText}</p>` : '';
    const tableHtml = `<table class="table">${htmlRows.join('')}</table>`;
  
    return `${introHtml}${tableHtml}`;
  }
  
  
  
  
  const initConversation = useCallback(async (tokenData: any) => {
    if (initialized.current) {
      return;
    }
  
    if (!tokenData?.token) return;
  
    const token = tokenData.token;
    const key = Date.now();
    setTokenToFeedback(token);
    localStorage.setItem('newToken', JSON.stringify(tokenData));
  
    if (session && session.directLine) {
      session.directLine.end();
    }
  
    const store = createStore({}, ({ dispatch }: any) => (next: any) => (action: any) => {
      const activity = action.payload?.activity;
    
      // Guardar reacciones
      if (
        (action.type === 'DIRECT_LINE/QUEUE_INCOMING_ACTIVITY' || action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') &&
        activity
      ) {
        // Reacciones
        if (activity.type === 'messageReaction' && activity.reactionsAdded?.length) {
          storeMessageReaction(action);
        }
      
        // Feedback con botón
        if (activity.type === 'message' && activity.attachments?.length) {
          const actions = activity.attachments[0].content?.actions;
          if (actions && actions[0]?.title === 'Provide feedback') {
            storeProvideFeedback(action);
          }
        }
      
        // Convertir tablas Markdown a HTML
        // Verifica si el texto es una tabla Markdown y la convierte a HTML
        if (
          activity.type === 'message' &&
          typeof activity.text === 'string' &&
          isMarkdownTable(activity.text)
        ) {
          const tableHtml = markdownTableToHtml(activity.text);
      
          action.payload.activity.text = undefined;
          action.payload.activity.attachments = [{
            contentType: 'application/vnd.microsoft.card.adaptive',
            content: {
              type: 'AdaptiveCard',
              version: '1.3',
              body: [{
                type: 'TextBlock',
                text: tableHtml,
                wrap: true
              }]
            }
          }];
        }
      }
      
    
      // Si es feedback enviado desde el usuario
      if (
        action.type === 'DIRECT_LINE/POST_ACTIVITY' &&
        activity?.value?.message &&
        !activity.text &&
        activity.value.action === 'send_feedback_to_bot'
      ) {
        dispatch({
          type: 'WEB_CHAT/SEND_MESSAGE_BACK',
          payload: {
            text: activity.value.message,
            value: activity.value,
          },
        });
        return;
      }
    
      // agrega channelData a la actividad
      if (action.type === 'DIRECT_LINE/POST_ACTIVITY' && activity) {
        const enrichedActivity = {
          ...activity,
          channelData: {
            ...(activity.channelData || {}),
            hubspotID: localStorage.getItem('hubspotID'),
            section: localStorage.getItem('section'),
            userName: localStorage.getItem('name'),
            userEmail: localStorage.getItem('email'),
            tokenOkta: tokenOkta,
          },
        };
    
        return next({
          ...action,
          payload: {
            ...action.payload,
            activity: enrichedActivity,
          },
        });
      }
    
      // Limpiar token si la conexión falla
      if (action.type === 'DIRECT_LINE/CONNECT_REJECTED') {
        localStorage.removeItem('newToken');
      }
    
      return next(action);
    });
    
  
    setSession({
      directLine: createDirectLine({ token }),
      key,
      store,
    });
  
    initialized.current = true;
  }, [session]);


  const onCloseModal = (value: IModalValue) => {
    dispatch(openOrCloseModal(value));
  };

  useEffect(() => {
    startBot();
    dispatch(userSendPrompt('New chat'));
   
  
    return () => {
    };
  }, [chatBotEvent]);

  const startBot = async () => {
    try {
      const newToken = localStorage.getItem('newToken');
      if (newToken) {
        const parsedToken = JSON.parse(newToken);
        const isValid = await validateToken(parsedToken)
        console.log("isValid ", isValid);
        if (isValid) {

          await initConversation(parsedToken);
          dispatch(resetChat(false));
        } else{
          const botToken = await getToken();
          if (botToken) {
            await initConversation(botToken);
          }
        }
      } else {
        const botToken = await getToken();
        if (botToken) {

          await initConversation(botToken);
        }
      }
    } catch (err) {
      console.error("Error iniciando conversación:", err);
    }
  };

  const validateToken = async (token: string) => {
    try {
      const response = await fetch("https://directline.botframework.com/v3/directline/conversations", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.ok;
    } catch (error) {
      console.error("Error al validar el token:", error);
      return false;
    }
  };
  const toggleChat = () => {
    setIsOpenbot(false);
  };
  const expandBot = () => {
    setFull(!isFull);
  };
  return (
    <>
      {/* <Toolbar /> */}
      <div className="layout">
        {/* <SideNav /> */}
        <main className="main-content">
          <div className="floating-chat-wrapper">
            <div className={`chat-panel ${isOpen ? "open" : ""}`}>
              <div className="d-flex justify-content-between align-items-center">
                <button className="chat-toggle-button" onClick={toggleChat}>
                  <img src={iconBot} alt="" width={25} className="me-2" />
                  Economics AI Agent
                </button>
                <div className="text-white d-flex align-items-center">
                  {!isFull && (
                    <button className="chat-toggle-button" onClick={toggleChat}>
                    <FontAwesomeIcon icon={faChevronUp} />
                    </button>
                  ) }
                
                  <button className="chat-toggle-button" onClick={expandBot}>
                    {isFull ? (
                     <FontAwesomeIcon icon={faCompress} />
                    ) : (
                      <FontAwesomeIcon icon={faExpand} />
                    )}
                    </button>
                </div>
              </div>
              {!!(session && session.directLine) && (
                <Components.Composer
                  styleOptions={chatBotStyles}
                  directLine={session.directLine}
                  key={session.key}
                  store={session.store}
                  activityMiddleware={activityMiddleware}
                >
                  <>
                    <WebChat
                      cardText={cardText}
                      homeVisibility={homeVisibility}
                    />

                    {modal.isOpen && modal.modalType === ModalType.Prompts && (
                      <Modal
                        title="Prompts Guide for LUCA Bot."
                        size="70rem"
                        onClose={() =>
                          onCloseModal({
                            isOpen: false,
                            modalType: ModalType.Prompts,
                          })
                        }
                        extraChildren={<GuidePromptsSearcher />}
                      >
                        <GuidePrompts
                          onClose={() =>
                            onCloseModal({
                              isOpen: false,
                              modalType: ModalType.Prompts,
                            })
                          }
                        />
                        <hr className="line" />
                        <Tips />
                      </Modal>
                    )}

                    {modal.isOpen && modal.modalType === ModalType.Feedback && (
                      <Modal
                        title="We ask you to provide feedback"
                        size="702px"
                        onClose={() =>
                          onCloseModal({
                            isOpen: false,
                            modalType: ModalType.Feedback,
                          })
                        }
                      >
                        <Feedback token={tokenToFeedback} />
                      </Modal>
                    )}
                  </>
                </Components.Composer>
              )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default memo(ChatBot);
